import { useCallback, useState } from 'react';

export const SCREENS_VIEW_KEY = 'pp-screens-view';
/** a company with MORE than this many screens opens in the list view; up to this many, the cards */
export const LIST_DEFAULT_ABOVE = 8;

const read = () => {
  try { const v = window.localStorage.getItem(SCREENS_VIEW_KEY); return v === 'list' || v === 'cards' ? v : null; } catch (e) { return null; }
};

/**
 * Which way the Screens page is drawn. The person's own choice (remembered per browser) wins; with no choice yet it is the list for
 * more than 8 screens, the cards otherwise. Storage can be blocked (private window): then it simply is not remembered.
 */
export function useScreensView(totalScreens) {
  const [saved, setSaved] = useState(read);
  const view = saved || (totalScreens > LIST_DEFAULT_ABOVE ? 'list' : 'cards');
  const setView = useCallback((v) => {
    setSaved(v);
    try { window.localStorage.setItem(SCREENS_VIEW_KEY, v); } catch (e) { /* not remembered */ }
  }, []);
  return [view, setView];
}
